const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  table: {},
  button: {
    ...theme.typography.button,
    textTransform: "none"
  },
  title: {
    fontSize: "3em"
  },
  cardContent: {
    padding: "0px !important"
  },
  cardActions: {
    padding: "4px 4px",
    height: "auto"
  },
  cardActionsTitle: {
    background: "#005795 !important",
    padding: "5px",
    textAlign: "center"
  },
  subtestpassed: {
    background: "#43A547!important",
    padding: "5px",
    textAlign: "center"
  },
  subtestfailed: {
    background: "#ff5252!important",
    padding: "5px",
    textAlign: "center"
  },
  subtesttitle: {
    color: "#FFFFFF"
  },
  cardActionsNav: {
    background: "#FF643B !important",
    padding: "5px",
    textAlign: "center"
  },
  nav: {
    padding: "initial",
    minWidth: "initial",
    minHeight: "initial"
  },
  borderpassed: {
    border: "2px solid #43A547"
  },
  borderfailed: {
    border: "2px solid #ff5252"
  },
  tablerow: {
    height: "15px"
  },
  tableheader: {
    padding: "8px 5px 9px 5px"
  },
  title: {
    fontSize: "2em"
  },
  subtestHeight: {
    height: 235
  },
  // tableContainer: {
  //  height: '100%',
  //  overflowY: 'auto'
  // },
  impedancePair: {
    display: "block"
  },
  impedancePairTitle: {
    display: "inline",
    marginRight: "10px",
    fontWeight: "bold"
  },
  impedancePairValue: {
    display: "inline"
  },
  hyphen: {
    fontSize: "1.5em",
    textAlign: "right"
  },
  topGridBordered: {
    marginTop: theme.spacing.unit * 2.5,
    borderBottom: "0.5px solid #D3D3D3",
    textAlign: "center",
    height: "60px"
  },
  centerGrid: {
    textAlign: "center",
    marginTop: theme.spacing.unit * 15
  },
  topGrid: {
    //borderBottom: "0.5px solid #D3D3D3",
    textAlign: "center",
    //height: "115px"
    marginTop: theme.spacing.unit * 1.5
  },
  leftGrid: {
    borderRight: "0.5px solid #D3D3D3",
    textAlign: "center",
    height: "115px"
  },
  rightGrid: {
    //borderRight: "0.5px solid #D3D3D3",
    textAlign: "center",
    height: "115px"
  },
  t_tar_text: {
    fontSize: "12pt"
    //marginTop: theme.spacing.unit * 3
  },
  t_tar_no: {
    fontSize: "30pt",
    fontWeight: "bold"
  },
  t_tar_no2: {
    fontSize: "11pt"
  },
  t_tar_text_p: {
    fontSize: "12pt",
    color: `${theme.palette.success} !important`,
    marginTop: theme.spacing.unit * 4
  },
  t_tar_no_p: {
    fontSize: "15pt",
    color: `${theme.palette.success} !important`,
    fontWeight: "bold"
  },
  t_tar_text_f: {
    fontSize: "12pt",
    color: `${theme.palette.fail} !important`,
    marginTop: theme.spacing.unit * 4
  },
  t_tar_no_f: {
    fontSize: "15pt",
    color: `${theme.palette.fail} !important`,
    fontWeight: "bold"
  }
});

export default styles;
